import { h } from 'preact';
import { useState } from 'preact/hooks';
import { useContext } from './context';
import register from '@wcd/preact-custom-element';
import format from 'date-fns/format';
import isToday from 'date-fns/isToday';
import isPast from 'date-fns/isPast';
import isTomorrow from 'date-fns/isTomorrow';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import { NullableDiscount } from '../../../types/models';
import { Price } from '../../../types/web-components';

const getDiscountDescription = ({ endDate, percentage }) => {
  const date = Date.parse(endDate);
  let ends = ``;
  if (isToday(date)) {
    ends = `, offer ends in ${formatDistanceToNow(date)}`;
  } else if (isTomorrow(date)) {
    ends = ', offer ends tomorrow';
  } else {
    ends = ` until ${format(date, 'dd MMMM yyyy')}`;
  }
  return `${percentage * 100}% off${ends}`;
};

const renderPrice = ({ formattedPrice, formattedDiscountPrice, discount }) => {
  if (discount) {
    const discountDescription = getDiscountDescription(discount);
    return (
      <article className="rdp-price fade-in">
        <div className="rdp-price__container">
          <div className="rdp-price__original fade-out">{formattedPrice}</div>
          <div className="rdp-price__discount-info fade-in">
            <span className="rdp-price--discounted">
              <span className="rdp-price--discounted__txt">Now </span>
              {formattedDiscountPrice}
            </span>
            <span className="rdp-price--old">was {formattedPrice}</span>
          </div>
        </div>
        <p className="rdp-price__discount-description">{discountDescription}</p>
      </article>
    );
  }

  return (
    <article className="rdp-price fade-in">
      <div className="rdp-price__container">
        <div className="rdp-price__original">{formattedPrice}</div>
      </div>
    </article>
  );
};

export const component: Price = ({ amount, symbol }) => {
  const [formattedPrice, setFormattedPrice] = useState(`${symbol}${Number(amount).toFixed(2)}`);
  const [discount, setDiscount] = useState<NullableDiscount>(null);
  const [formattedDiscountPrice, setFormattedDiscountPrice] = useState('');
  const [owns, setOwns] = useState(false);

  useContext(({ user, resource }) => {
    // immediately invoked async function, as the function passed to useEffect cannot be async.
    const {
      currentDiscount = null,
      formattedDiscountPrice = '',
      formattedPrice: currencyConvertedPrice
    }: any = resource;
    setFormattedPrice(currencyConvertedPrice);
    setDiscount(currentDiscount);
    setFormattedDiscountPrice(formattedDiscountPrice);
    setOwns(Boolean(user?.owns));

    let interval;
    // we need to invalidate the discount if it expires while showing the page. this might be a candidate abstraction if we encounter other web-components needing to do similar.
    if (currentDiscount) {
      interval = setInterval(() => {
        const endDate = Date.parse(currentDiscount.endDate as any);
        if (isPast(endDate)) {
          setDiscount(null);
          clearInterval(interval);
        }
      }, 1000);
    }
  });

  if (!owns) {
    return renderPrice({ discount, formattedPrice, formattedDiscountPrice });
  }

  return null;
};

register(component, 'tes-price', ['amount', 'symbol'], { shadow: false });
